<template>
  <article class="modal_password">
    <section class="modal_password__modal">
      <div class="modal_password__modal__info"  v-if="type==='audio'">
        <h5 style="margin-bottom:10px;">¿Está seguro?</h5>
        <p style="margin-bottom:10px;">¿Desea marcar como revisado este audio?</p>
        <input type="text" placeholder="¿Quién revisa?" v-model.trim="whoReviews" style="width: 100%; margin-bottom:10px">  
        <textarea v-model.trim="Comments" style="width: 100%" cols="30" rows="10" placeholder="Comentarios"></textarea>    
      </div>
      <div class="modal_password__modal__info"  v-else-if="type==='alertas'">
        <h5 style="margin-bottom:10px;">¿Está seguro?</h5>
        <p style="margin-bottom:10px;">¿Desea marcar como revisada esta alerta?</p>  
        <input type="text" placeholder="¿Quién revisa?" v-model.trim="whoReviews" style="width: 100%; margin-bottom:10px" >   
        <textarea v-model.trim="Comments" style="width: 100%" cols="30" rows="10" placeholder="Comentarios"></textarea>    
      </div>
      <div class="modal_password__modal__info"  v-else>
        <h5 style="margin-bottom:10px;">¿Está seguro?</h5>
        <p style="margin-bottom:10px;">Mencione a continuación los hechos por los cuales el guarda no generó el reporte.</p>   
        <input type="text" placeholder="¿Quién revisa?" v-model.trim="whoReviews" style="width: 100%; margin-bottom:10px" >   
        <textarea v-model.trim="Comments" style="width: 100%" cols="30" rows="10" placeholder="Comentarios"></textarea>   
      </div>
      <div class="modal_password__modal__buttons" v-if="type==='audio'">
        <button @click="onActivateModal(true)" class="modal_password__modal__buttons--left" :disabled="!acceptBtn">
          REVISADO
        </button>
        <button @click="onCancelModal" class="modal_password__modal__buttons--right">
          CANCELAR
        </button>
      </div>
      <div class="modal_password__modal__buttons" v-else-if="type==='alertas'">
        <button @click="onActivateModal(true)" class="modal_password__modal__buttons--left" :disabled="!acceptBtn">
          REVISADA
        </button>
        <button @click="onCancelModal" class="modal_password__modal__buttons--right">
          CANCELAR
        </button>
      </div>
      <div class="modal_password__modal__buttons" v-else>
        <button @click="onActivateModal(true)" class="modal_password__modal__buttons--left" :disabled="!acceptBtn">
          JUSTIFICADO
        </button>
        <button @click="onActivateModal(false)" class="modal_password__modal__buttons--left" :disabled="!acceptBtn">
          INJUSTIFICADO
        </button>
        <button @click="onCancelModal" class="modal_password__modal__buttons--right">
          CANCELAR
        </button>
      </div>
    </section>
  </article>
</template>

<script>
import moment from 'moment'
export default {
  props:{
    turno:{
      type: Object,
      required:true
    },
    type:{
      type: String,
    }
  },
  data(){
    return{
      fecha:"",
      errorMessage:"",
      Comments: null,
      whoReviews: this.getUserInfo().name+' '+this.getUserInfo().last_name
    }
  },
  methods:{
    onCancelModal(event){      
      this.$emit('cancel', false);
    },
    onActivateModal(event){    
      if (this.Comments != null || this.whoReviews != null || this.Comments != "" || this.whoReviews != "") {
        this.$emit('activate',[this.turno,event, this.Comments, this.whoReviews]); 
      } else{
        alert('Debe ingresar una anotación del procedimiento realizado y el nombre de la persona que lo revisa.')
      }
      
    }
  }, 
  computed: {
    acceptBtn(){
      if(this.Comments == null || this.whoReviews == null || this.Comments == "" || this.whoReviews == ""){
        return false;
      }
      return true;
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ModalRectify.vue